import { Megaphone, ListTodo, Settings, UserCircle, Building2, Boxes, ChartColumnIncreasing, Swords, Sparkles, FileText, Rocket, Palette, BarChart3, Settings2 } from 'lucide-react';

// Regular navigation items shown to all users
export const navigation = [
  {
    name: 'Setup',
    to: '/setup',
    icon: Settings2,
    testModeOnly: true,
  },
  {
    name: 'Business',
    to: '/business',
    icon: Rocket,
  },
  {
    // Strategy (Goals) moved into the Setup page as the purple "Strategy" tab (#6011); the
    // standalone sidebar item is retired. /strategy now redirects to /setup#strategy.
    name: 'Assets',
    to: '/assets',
    icon: Palette,
  },
  {
    name: 'Campaigns',
    to: '/campaigns',
    icon: Megaphone,
  },
  {
    name: 'Performance',
    to: '/performance',
    icon: ChartColumnIncreasing,
  },
  {
    // Consolidated (Unified) Performance surface (#5971), test-mode only for now. /performance-v2
    // and /meta-performance are retired (#6052); the legacy /performance stays live.
    name: 'Performance (Unified)',
    to: '/performance-consolidated',
    icon: BarChart3,
    testModeOnly: true,
  },
  {
    name: 'Reports',
    to: '/reports',
    icon: FileText,
  },
  {
    name: 'Competitors',
    to: '/competitors',
    icon: Swords,
  },
  {
    name: 'Optimizations',
    to: '/optimizations',
    icon: Sparkles,
  },
];

// Bottom navigation items
export const bottomNavigation = [
  {
    name: 'Account',
    to: '/settings/account',
    icon: UserCircle,
  },
  {
    name: 'Organizations',
    to: '/organizations',
    icon: Building2,
  },
  // Note: Third nav item (individual org) will be dynamically generated with org name
];

// Admin-only navigation items
export const adminNavigation = [
  {
    name: 'Components',
    to: '/components',
    icon: Boxes,
  },
  {
    name: "Automations",
    to: '/tasks',
    icon: ListTodo,
  },
  {
    name: 'Glitch Admin',
    to: '/admin',
    icon: Settings,
  },
];
